{
  "id": "anp-combustiveis",
  "nome": "ANP — Levantamento de Preços de Combustíveis (LPC)",
  "fonte": "ANP — resumo_semanal_lpc (municipal averages)",
  "endpoints": [
    "https://www.gov.br/anp/pt-br/assuntos/precos-e-defesa-da-concorrencia/precos/levantamento-de-precos-de-combustiveis-ultimas-semanas-pesquisadas",
    "https://www.gov.br/anp/pt-br/assuntos/precos-e-defesa-da-concorrencia/precos/arquivos-lpc/2026/resumo_semanal_lpc_2026-07-26_2026-08-01.xlsx"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T06:10:48.933Z",
  "contagens": {
    "semanas": 1,
    "precosMedios": 2358,
    "municipios": 386,
    "produtos": 7,
    "ufs": 27
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "semanal",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T06:10:48.933Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#anp-combustiveis"
}
